import React from 'react';
interface SectionLabelProps {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
}
export function SectionLabel({
  children,
  tone = 'dark'
}: SectionLabelProps) {
  return <p className={`flex items-center gap-3 text-[0.68rem] font-semibold uppercase tracking-label ${tone === 'light' ? 'text-goldSoft' : 'text-gold'}`} data-id="element-243" data-mp="1cpc3jv3t9n1j">
      <span className={`h-px w-6 ${tone === 'light' ? 'bg-goldSoft/60' : 'bg-gold/50'}`} aria-hidden="true" data-id="element-244" data-mp="17sbxhk6yokaf" />
      {children}
    </p>;
}